import { URL_REGEX } from 'constants/validateRules';

export const isCorrectUrlFormat = (url: string): boolean => {
  return URL_REGEX.test(url);
};
